import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TRADES_QUERY_KEY } from "./useTrades";

type Body = components["schemas"]["BulkAssignTradeStrategyBody"];
type Response = components["schemas"]["BulkTradesResponse"];

export function useBulkAssignTradeStrategy() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<Response, Error, Body>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST("/api/trades/bulk/strategy", { body });
      if (error !== undefined) {
        throw new Error("Failed to assign strategy to selected trades");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TRADES_QUERY_KEY });
    },
  });
}
